// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-pin-container {
    position: fixed;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -60%);
    background-color: white;
    padding: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.629);
    z-index: 5000;
    width: 60%;
    text-align: center;
    font-weight: bold;
    border-radius:10px;
    display:block;
}


#pin-confirm-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px;
    padding-left: 10px;
    padding-right:10px;
    margin: 5px;
    cursor: pointer;
    border-radius: 5px;
}





`, "",{"version":3,"sources":["webpack://./src/css/eventPinSelector.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,6CAA6C;IAC7C,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".event-pin-container {\n    position: fixed;\n    top: 10%;\n    left: 50%;\n    transform: translate(-50%, -60%);\n    background-color: white;\n    padding: 10px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.629);\n    z-index: 5000;\n    width: 60%;\n    text-align: center;\n    font-weight: bold;\n    border-radius:10px;\n    display:block;\n}\n\n\n#pin-confirm-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px;\n    padding-left: 10px;\n    padding-right:10px;\n    margin: 5px;\n    cursor: pointer;\n    border-radius: 5px;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
